import { render, staticRenderFns } from "./AdminInvoiceForModelTableRow.vue?vue&type=template&id=ccb0953c&"
import script from "./AdminInvoiceForModelTableRow.vue?vue&type=script&lang=ts&"
export * from "./AdminInvoiceForModelTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports